<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.contact_admins") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #EF3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="row justify-content-center">
            <div class="col-l2">
              <div class="add_another" @click="addRow()">
                <i class="fas fa-plus"></i>
              </div>
            </div>
            <div
              class="col-lg-6 col-12"
              v-for="(item, index) in phones"
              :key="'l' + index"
            >
              <div class="item d-flex align-items-center">
                <base-input
                  class="w-100"
                  type="tel"
                  :placeholder="$t('PLACEHOLDERS.phone')"
                  v-model.trim="item.phone"
                />

                <div class="all_actions">
                  <span
                    class="add_another remove_phone_number"
                    @click="removeRow(index)"
                  >
                    <i class="fas fa-minus"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
            v-model.trim="data.WhatsApp_contact"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- Start:: Delivery Price Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          /> -->
          <!-- End:: Delivery Price Input -->

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.snap_link')"
            v-model.trim="data.snap"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- Start:: Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook')"
            v-model.trim="data.facebook"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.instagram"
          />
          <!-- End:: Input -->

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.youtube')"
            v-model.trim="data.youtube"
          />
          <!-- End:: Tax Percentage Input -->
          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.x')"
            v-model.trim="data.x"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok_link')"
            v-model.trim="data.tiktok"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- <base-input
            type="text"
            col="6"
            :placeholder="`${$t('PLACEHOLDERS.app_store_link')}`"
            v-model.trim="data.app_store_link"
            required
          /> -->
          <!-- <base-input
            type="text"
            col="6"
            :placeholder="`${$t('PLACEHOLDERS.google_play_link')}`"
            v-model.trim="data.google_play_link"
            required
          /> -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>

      <div class="contact_preview_wrapper">
        <div class="preview_header">
          <h5>{{ $t("STATIC_PAGES.contact") }}</h5>
          <router-link to="/home/static-pages/contact" class="preview_btn">
            <i class="fas fa-external-link-alt"></i>
            {{ $t("STATIC_PAGES.previewPage") }}
          </router-link>
        </div>
        <social-contact-display :contact-data="previewContacts" />
      </div>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
import SocialContactDisplay from "@/components/general/SocialContactDisplay.vue";

export default {
  name: "GeneralSettings",

  components: {
    SocialContactDisplay,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        WhatsApp_contact: null,
        linkedIn_link: null,
        facebook: null,
        // tiktok_link: null,
        instagram_link: null,
        snapchat: null,
        youtube: null,
        x: null,
        android: null,
        email: null,
        snap: null,
        facebook: null,
        instagram: null,
        app_store_link: null,
        google_play_link: null,
      },
      // End:: Data Collection To Send

      phones: [
        {
          phone: "",
        },
      ],
    };
  },

  computed: {
    previewContacts() {
      const mobile = this.phones
        .map((item) => item.phone)
        .filter((phone) => String(phone).trim());

      return {
        facebook: this.data.facebook,
        instagram: this.data.instagram,
        snapchat: this.data.snap,
        tiktok: this.data.tiktok,
        whatsapp: this.data.WhatsApp_contact,
        x: this.data.x,
        mobile,
      };
    },
  },

  methods: {
    addRow() {
      this.phones?.push({ phone: "" });
    },

    removeRow(index) {
      this.phones.splice(index, 1);
    },

    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings?key=app-contacts`,
        });
        // Start:: Set Data

        // Extract value object from response
        const value = res.data.data.data[0].value;
        
        this.data.facebook = value.facebook;
        this.data.instagram = value.instagram;
        this.data.snap = value.snapchat;
        this.data.tiktok = value.tiktok;
        this.data.x = value.x;
        this.data.youtube = value?.youtube;
        this.data.WhatsApp_contact = value.whatsapp;

        // Transform the API response
        if (value.mobile) {
          this.phones = value.mobile?.map((phone) => ({
            phone: phone,
          }));
        } else {
          this.phones = [
            {
              phone: "",
            },
          ];
        }

        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = !this.isWaitingRequest;

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "app-contacts");
      this.phones.forEach((element, index) => {
        if (element.phone) {
          REQUEST_DATA.append(`value[mobile][${index}]`, element.phone);
        }
      });
      if (this.data.WhatsApp_contact) {
        REQUEST_DATA.append("value[whatsapp]", this.data.WhatsApp_contact);
      }
      if (this.data.tiktok) {
        REQUEST_DATA.append("value[tiktok]", this.data.tiktok);
      }
      if (this.data.youtube) {
        REQUEST_DATA.append("value[youtube]", this.data.youtube);
      }
      if (this.data.x) {
        REQUEST_DATA.append("value[x]", this.data.x);
      }
      if (this.data.instagram) {
        REQUEST_DATA.append("value[instagram]", this.data.instagram);
      }
      // if (this.data.android) {
      //   REQUEST_DATA.append("value[android]", this.data.android);
      // }
      // if (this.data.ios) {
      //   REQUEST_DATA.append("value[ios]", this.data.ios);
      // }
      // if (this.data.email) {
      //   REQUEST_DATA.append("value[email]", this.data.email);
      // }
      if (this.data.snap) {
        REQUEST_DATA.append("value[snapchat]", this.data.snap);
      }
      if (this.data.facebook) {
        REQUEST_DATA.append("value[facebook]", this.data.facebook);
      }


      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.submitForm();
    },
    // End:: validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.item {
  gap: 10px;
}

.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}

.contact_preview_wrapper {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--light_gray_clr);
}

.preview_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  h5 {
    margin: 0;
  }
}

.preview_btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #ef3405;
  font-weight: 600;
}
</style>
